import { render, staticRenderFns } from "./MacroTemplate.vue?vue&type=template&id=49cae5b8&"
import script from "./MacroTemplate.vue?vue&type=script&lang=js&"
export * from "./MacroTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports